/* eslint-disable @typescript-eslint/no-explicit-any */

const logger = {
  log: (...args: any[]): void => {
    if (process.env.NODE_ENV !== 'production') {
      console.log(...args);
    }
  },
  error: (...args: any[]): void => {
    console.error(...args);
  },
  warn: (...args: any[]): void => {
    console.warn(...args);
  },
  // Add more methods as needed (e.g., info, debug)
};

export default logger;
